import { useEffect } from "react";

const NoIndex = ({ enabled = true }) => {
  useEffect(() => {
    if (!enabled || typeof document === "undefined") return;

    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    meta.setAttribute("data-testid", "noindex-meta");
    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, [enabled]);

  return null;
};

export default NoIndex;
